import { doc, setDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/config";

function grantRef(competitionId, uid) {
  return doc(db, "competitions", competitionId, "grants", uid);
}

function grantsCol(competitionId) {
  return collection(db, "competitions", competitionId, "grants");
}

/**
 * @param {string} competitionId
 */
export async function listCompetitionGrants(competitionId) {
  const snap = await getDocs(grantsCol(competitionId));
  return snap.docs.map((d) => d.data());
}

/**
 * @param {string} competitionId
 * @param {string} uid
 * @param {string[]} permissions
 */
export async function upsertCompetitionGrant(competitionId, uid, permissions) {
  await setDoc(
    grantRef(competitionId, uid),
    {
      grantId: `${competitionId}_${uid}`,
      principalId: uid,
      scopeType: "competition",
      scopeId: competitionId,
      permissions,
      updatedAtMs: Date.now(),
    },
    { merge: true }
  );
}
